import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import React, { Component } from "react";

import "leaflet/dist/leaflet.css";

import { toast } from "react-toastify";

import { withRouter } from "react-router-dom";
import { AddAds, GetAdsById, EditAds, Upload } from "../../fetchs";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class User extends Component {
  constructor(props) {
    super(props);
    // const [hasLocation, sethasLocation] = useState(false);
    // const [latlng, setllatlng] = useState({ lat: 29.5926, lng: 52.5836 });

    this.state = {
      latlng: {
        lat: 29.5926,
        lng: 52.5836,
      },
      name: "",
      nameHelper: "",
      workTime: "",
      workTimeHelper: "",
      family: "",
      email: "",
      city: [],
      province: [],
      addressText: "",
      addressTextHelper: "",
      addressList: [
        {
          addressText: "",
          longitude: 52.5836,
          latitude: 29.5926,
          doctorId: "",
          tell: "",
        },
      ],

      description: "",
      phone: "",
      phoneHelper: "",
      zone: "",
      isOpenAtNight: false,

      loading: false,
      saving: false,
      pic: null,
      uploadPic: "",
      doctorId: null,
      render: false,
    };
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      GetAdsById(this.props.match.params.id)
        .then((response) => {
          return response.json();
        })
        .then((responseJson) => {
          this.setState({
            id: responseJson.id,
            name: responseJson.name,
            zone: responseJson.zone,
            phone: responseJson.phone,
            workTime: responseJson.workTime,
            cityId: responseJson.cityId,
            provinceId: responseJson.provinceId,
            pic: responseJson.imageAddress,
            addressText: responseJson.addressList[0].addressText,
            // latlnglng: responseJson.addressList,
            description: responseJson.description,
            isOpenAtNight: responseJson.isOpenAtNight,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  handleSave = () => {
    if (this.props.match.params.id) {
      EditAds(this.props.match.params.id, {
        name: this.state.name,
        family: "",
        email: "",
        userTypeId: "968d1b3f-ca26-414b-8879-bd026b65fa88",
        zone: this.state.zone,
        phone: this.state.phone,
        workTime: this.state.workTime,
        description: this.state.description,
        isOpenAtNight: this.state.isOpenAtNight,
        cityId: this.state.cityId,
        provinceId: this.state.provinceId,

        imageAddress: this.state.pic,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای ویرایش شدن تبلیغ");
            console.log(response);
          } else if (response.status === 200) {
            toast.success("تیلیغ با موفقیت ویرایش شد");
            this.props.history.push("/main/adss");
            this.setState({ render: !this.state.render });
          }
          return response.json();
        })
        .then((responseJson) => {
          console.log(responseJson.message);
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      AddAds({
        userTypeId: "968d1b3f-ca26-414b-8879-bd026b65fa88",
        name: this.state.name,
        zone: this.state.zone,
        family: "",
        email: "",
        phone: this.state.phone,
        workTime: this.state.workTime,
        description: this.state.description,
        isOpenAtNight: this.state.isOpenAtNight,
        cityId: this.state.cityId,
        provinceId: this.state.provinceId,

        imageAddress: this.state.pic,
      })
        .then((response) => {
          if (response.status !== 200) {
            toast.error("خطای اضافه شدن تبلیغ");
            console.log(response);
          } else if (response.status === 200) {
            toast.success("تبلیغ با موفقیت اضافه شد");
            this.props.history.push("/main/adss");
            this.setState({ render: !this.state.render });
          }
          return response.json();
        })
        .then((responseJson) => {
          console.log(responseJson);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  handleSelectFile = (event) => {
    Upload(event.target.files[0], "1")
      .then((response) => {
        return response.text();
      })
      .then((responseJson) => {
        this.setState({ imgUrl: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleCheckChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }

        break;
      case "workTime":
        this.setState({ workTime: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            workTimeHelper: "لطفا ساعت کاری را وارد کنید=> مثال : 8 الی 18",
          });
        } else {
          this.setState({ workTimeHelper: "" });
        }

        break;
      case "phone":
        this.setState({ phone: event.target.value });
        valid = /^[0-9]+$/.test(event.target.value);
        if (!valid) {
          this.setState({ phoneHelper: "لطفا شماره تماس را عدد وارد کنید" });
        } else {
          this.setState({ phoneHelper: "" });
        }

        break;

      case "addressText":
        this.setState({ addressText: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({
            addressTextHelper: "لطفا آدرس را وارد کنید",
          });
        } else {
          this.setState({ addressTextHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete='off'>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id='name'
                      label='نام'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin='normal'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.workTimeHelper.length !== 0}
                      helperText={this.state.workTimeHelper}
                      onChange={this.onchange}
                      id='workTime'
                      label='ساعت کاری '
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.workTime}
                      margin='normal'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id='standard-select-province'
                      select
                      label='  استان'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChange("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.province.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id='standard-select-city'
                      select
                      label='  شهر'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin='normal'
                    >
                      {this.state.city.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.phoneHelper.length !== 0}
                      helperText={this.state.phoneHelper}
                      onChange={this.onchange}
                      id='phone'
                      label='شماره تماس'
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.phone}
                      margin='normal'
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id='standard-email'
                      label='منطقه'
                      fullWidth
                      type='email'
                      className={classes.textField}
                      value={this.state.zone}
                      onChange={this.handleChange("zone")}
                      margin='normal'
                    />
                  </Grid>
                  <Grid item xs={12} lg={12}>
                    <TextareaAutosize
                      error={this.state.addressTextHelper.length !== 0}
                      helperText={this.state.addressTextHelper}
                      onChange={this.onchange}
                      rowsMin={8}
                      id='addressText'
                      label='آدرس'
                      // fullWidth
                      placeholder='آدرس'
                      // className={classes.textField}
                      value={this.state.addressText}
                      margin='normal'
                    />
                  </Grid>

                  <Grid item xs={12} lg={12}>
                    <TextareaAutosize
                      rowsMin={8}
                      id='standard-description'
                      label='توضیحات'
                      // fullWidth
                      placeholder='توضیحات'
                      // className={classes.textField}
                      value={this.state.description}
                      onChange={this.handleChange("description")}
                      margin='normal'
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <input
                      accept='image/*'
                      className={classes.input}
                      style={{ display: "none" }}
                      id='raised-button-file'
                      multiple
                      type='file'
                      onChange={this.handleSelectFile}
                    />
                    <label htmlFor='raised-button-file'>
                      <Button
                        fullWidth
                        variant='contained'
                        component='span'
                        className={classes.button}
                      >
                        ارسال عکس داروخانه
                      </Button>
                      {this.state.uploadPic && (
                        <CircularProgress
                          size={24}
                          className={classes.buttonProgress}
                        />
                      )}
                    </label>
                    <div>
                      <div className='picParent'>
                        <img
                          src={`http://medix-app.ir/${this.state.pic}`}
                          className='picture'
                          alt={this.state.name}
                        />
                      </div>
                    </div>
                  </Grid>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.isOpenAtNight}
                        onChange={this.handleCheckChange("isOpenAtNight")}
                        value='isOpenAtNight'
                        color='primary'
                      />
                    }
                    label=' شبانه روزی'
                  />

                  <Grid item xs={12}>
                    <Button
                      variant='contained'
                      color='primary'
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        this.state.name.length === 0 ||
                        this.state.phoneHelper.length !== 0 ||
                        this.state.phone.length === 0 ||
                        this.state.addressTextHelper.length !== 0 ||
                        this.state.addressText.length === 0 ||
                        this.state.workTimeHelper.length === 0 ||
                        this.state.workTime.length === 0
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    );
  }
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
